<template>
  <fragment>
    <Loading
      v-if="paginando"
      :full-page="true"
      :color="$vuetify.theme.themes.light.primary"
    />
    <v-row
      no-gutters
      class="py-0"
    >
      <v-col
        cols="12"
        md="5"
        class="pr-0"
      >
        <div class="d-flex justify-start align-center">
          <v-autocomplete
            v-if="cotizadorHotels.destino === null || cotizadorHotels.destino === ''"
            v-model="cotizadorHotels.destino"
            :items="itemsDestinos"
            :search-input.sync="searchDestinos"
            :label="$t('lbl.hotelDestinos')"
            outlined
            dense
            item-text="name"
            item-value="id"
            single-line
            clearable
            return-object
            class="pr-2"
            @change="changeDestinos"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ noResultDestinos ? $t('lbl.noResultSearchFlight') : $t('lbl.hotelDestinos') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:item="{ item }">
              <v-icon left>
                {{ item.icon }}
              </v-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:selection="{ item }">
              {{ item.name }}
            </template>
          </v-autocomplete>
          <v-text-field
            v-else
            ref="autocomplete"
            v-model="cotizadorHotels.destino.name"
            :label="$t('lbl.hotelDestinos')"
            outlined
            dense
            single-line
            clearable
            @click:clear="clearDestinos"
            @input="inputDestinos"
          >
          </v-text-field>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="pl-5"
      >
        <v-menu
          v-model="menuFrom"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedFromDateFormatted"
              :label="$t('lbl.dateIn')"
              persistent-hint
              readonly
              v-bind="attrs"
              outlined
              dense
              style="border-radius: 5px 0px 0px 5px"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="cotizadorHotels.dateIn"
            no-title
            :min="minDate.toISOString().substr(0, 10)"
            locale="es"
            :show-current="false"
            @input="
              menuFrom = false
              activeToDate()
            "
          ></v-date-picker>
        </v-menu>
        <!--<vc-date-picker
          v-model="cotizadorHotels.dateIn"
          outlined
          dense
          hide-details
          :min-date="minDate"
          mode="date"
          :model-config="modelConfig"
          class="d-flex justify-center;z-index: 1 !important"
          @input="activeToDate"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <v-text-field
              :label="$t('lbl.dateIn')"
              outlined
              dense
              :value="inputValue"
              style="border-radius: 5px 0px 0px 5px"
              v-on="inputEvents"
            >
            </v-text-field>
          </template>
        </vc-date-picker>-->
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="pl-5"
      >
        <v-menu
          v-model="menuTo"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedToDateFormatted"
              :disabled="!cotizadorHotels.dateIn"
              :label="$t('lbl.dateOut')"
              persistent-hint
              readonly
              v-bind="attrs"
              outlined
              dense
              style="border-radius: 0px 5px 5px 0px"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="cotizadorHotels.dateOut"
            no-title
            locale="es"
            :show-current="false"
            :min="
              cotizadorHotels.dateIn
                ? $moment(cotizadorHotels.dateIn)
                  .add(1, 'day')
                  .toDate()
                  .toISOString()
                  .substr(0, 10)
                : minDate
            "
            @input="menuTo = false"
          ></v-date-picker>
        </v-menu>
        <!--<vc-date-picker
          v-model="cotizadorHotels.dateOut"
          outlined
          dense
          hide-details
          :min-date="
            $moment(cotizadorHotels.dateIn)
              .add(1, 'days')
              .toDate()
          "
          mode="date"
          :model-config="modelConfig"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <v-text-field
              ref="dateTo"
              :disabled="!cotizadorHotels.dateIn"
              :label="$t('lbl.dateOut')"
              outlined
              dense
              :value="inputValue"
              style="border-radius: 0px 5px 5px 0px"
              v-on="inputEvents"
            >
            </v-text-field>
          </template>
        </vc-date-picker>-->
      </v-col>
      <v-col
        cols="12"
        md="3"
        class="pl-5"
      >
        <v-btn
          align="left"
          block
          class="font-weight-medium"
          outlined
          color="#8a8d93"
          style="text-transform: capitalize; justify-content: left;"
          @click="changeOcupation"
        >
          <v-icon left>
            mdi-human-male-girl
          </v-icon>
          {{
            `${
              cotizadorHotels.ocupation
                ? `${cantViajeros} ${$t('lbl.travels')}, ${cotizadorHotels.ocupation.length} ${$t('lbl.roomD')}`
                : $t('lbl.ocupation')
            }`
          }}
        </v-btn>
        <fragment v-if="showOcupationRoomHotel">
          <v-container
            fluid
            pa-0
            class="container-chat col-lg-3 col-md-3 col-sm-3 col-xs-3 pl-7"
          >
            <HotelOcupation :config-search="configSearch" />
          </v-container>
        </fragment>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-autocomplete
          v-model="cotizadorHotels.proveedor_id"
          :items="itemsProveedor"
          :search-input.sync="searchProveedor"
          hide-details
          hide-selected
          :label="$t('lbl.proveedor')"
          outlined
          dense
          item-text="name_comercial"
          item-value="id"
          clearable
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-title>
                {{ $t('lbl.proveedor') }}
              </v-list-item-title>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item }">
            <span v-text="item.name_comercial"></span>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.name_comercial }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-select
          v-model="cotizadorHotels.categoria_id"
          :items="categories"
          item-text="name"
          item-value="id"
          :label="$t('menu.category')"
          outlined
          dense
          hide-details
          clearable
        >
          <template v-slot:selection="{ item }">
            <span v-if="item.name !== null">
              {{ item.name }}
              <span v-if="item.plus">PLUS</span>
            </span>
            <span v-if="item.name === null">
              <v-row>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-rating
                    v-model="item.cant_estrellas"
                    color="primary"
                    size="25"
                    readonly
                  ></v-rating>
                </v-col>
                <!--<v-col
                  cols="12"
                  md="4"
                  class="mt-2"
                >
                  <span v-if="item.plus">PLUS</span>
                </v-col>-->
              </v-row>
            </span>
          </template>

          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title v-if="item.name !== null">
                {{ item.name }}
                <span v-if="item.plus">PLUS</span>
              </v-list-item-title>
              <v-list-item-title v-if="item.name === null">
                <v-row>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-rating
                      v-model="item.cant_estrellas"
                      color="primary"
                      readonly
                      size="30"
                    ></v-rating>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <p
                      v-if="item.plus"
                      class="pt-3"
                    >
                      PLUS
                    </p>
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <!--<v-autocomplete
          v-model="cotizadorHotels.tipo_destino_id"
          :items="itemsTipoDestino"
          :search-input.sync="searchTipoDestino"
          hide-details
          hide-selected
          :label="$t('menu.typeDestination')"
          outlined
          dense
          item-text="name"
          item-value="id"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-title>
                {{ $t('menu.typeDestination') }}
              </v-list-item-title>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item }">
            <span v-text="item.name"></span>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>-->
        <v-select
          v-model="cotizadorHotels.tipo_destino_id"
          :items="allTipoDestino"
          item-text="name"
          item-value="id"
          :label="$t('menu.typeDestination')"
          outlined
          dense
          hide-details
        >
          <template v-slot:selection="{ item }">
            <span v-if="item.name">
              {{ item.name }}
              <span v-if="item.plus">PLUS</span>
            </span>
          </template>

          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.name }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-row>
          <v-col
            cols="12"
            :md="
              !cotizadorHotels.destino &&
                !cotizadorHotels.dateIn &&
                !cotizadorHotels.dateOut &&
                cotizadorHotels.ocupation.length === 1 &&
                !cotizadorHotels.proveedor_id &&
                !cotizadorHotels.categoria_id &&
                !cotizadorHotels.tipo_destino_id
                ? '12'
                : '6'
            "
          >
            <v-btn
              color="primary"
              width="100%"
              :loading="loadingSearch"
              @click="
                resetPagination()
                search()
              "
            >
              {{ $t('btn.search') }}
            </v-btn>
          </v-col>
          <v-col
            v-if="
              cotizadorHotels.destino ||
                cotizadorHotels.dateIn ||
                cotizadorHotels.dateOut ||
                cotizadorHotels.ocupation.length > 1 ||
                cotizadorHotels.proveedor_id ||
                cotizadorHotels.categoria_id ||
                cotizadorHotels.tipo_destino_id
            "
            cols="12"
            md="6"
          >
            <v-btn
              color="error"
              width="100%"
              @click="clearForm"
            >
              {{ $t('btn.clear') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <fragment v-if="!loadingSearch && cotizadorHotelsResult.length > 0">
      <!--<v-card-text>
        <v-row>
          <v-spacer></v-spacer>

          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="per_page"
              :label="$t('lbl.itemsPerPage')"
              type="number"
              min="5"
              hide-details
              dense
              outlined
              @input="search()"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>-->
      <DisponibilidadHotels />
      <v-card-text class="pt-2">
        <v-row>
          <v-col
            lg="12"
            cols="12"
            class="d-flex justify-end"
          >
            <v-pagination
              v-model="pagination.current"
              :length="pagination.total"
              total-visible="5"
              @input="onPageChange"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </fragment>

    <NoResultsHotels v-else-if="searchingHotel" />
    <div
      v-else
      style="min-height: 250px;"
    ></div>
  </fragment>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import {
  mdiCar,
  mdiBed,
  mdiSeatPassenger,
  mdiWalletTravel,
  mdiAirplaneTakeoff,
  mdiAirplane,
  mdiAirplaneLanding,
  mdiSwapHorizontal,
  mdiOfficeBuilding,
  mdiEye,
  mdiPencil,
  mdiDelete,
  mdiPlusThick,
  mdiChevronRight,
  mdiPlus,
  mdiMinus,
} from '@mdi/js'
// eslint-disable-next-line no-unused-vars, import/no-unresolved
import Loading from '@/views/utils/loading/bars.vue'
import HotelOcupation from './HotelOcupation.vue'

import DisponibilidadHotels from '../disponibilidad/hotels/Index.vue'
import NoResultsHotels from './NoResultsHotels.vue'

export default {
  components: {
    Loading,
    HotelOcupation,
    DisponibilidadHotels,
    NoResultsHotels,
  },
  data() {
    return {
      paginando: false,
      pagination: {
        current: 1,
        total: 0,
      },
      menu: false,
      page: 1,
      per_page: 5,
      itemsDestinos: [],
      noResultDestinos: false,
      searchDestinos: null,
      loading: false,
      loadingSearch: false,
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      icons: {
        mdiCar,
        mdiBed,
        mdiSeatPassenger,
        mdiWalletTravel,
        mdiAirplaneTakeoff,
        mdiAirplane,
        mdiAirplaneLanding,
        mdiSwapHorizontal,
        mdiOfficeBuilding,
        mdiEye,
        mdiPencil,
        mdiDelete,
        mdiPlusThick,
        mdiChevronRight,
        mdiPlus,
        mdiMinus,
      },
      model: {},
      transmisiones: [],
      no_include_hour_recogida: true,
      no_include_hour_entrega: true,
      hours_recogida: [],
      hours_entrega: [],
      semanas: [],
      configSearch: {
        days_calendar_in: null,
        days_calendar_out: null,
        pax_adult: null,
        pax_child: null,
        age_child: null,
        age_infant: null,
        max_paxs_all: null,
        max_rooms: null,
        max_paxs_room: null,
        max_adult_room: null,
        max_child_room: null,
        min_adult_room: null,
        min_child_room: null,
      },
      minDate: new Date(),
      proveedores: [],
      itemsProveedor: [],
      searchProveedor: null,
      categories: [],
      itemsTipoDestino: [],
      allTipoDestino: [],
      searchTipoDestino: null,
      menuFrom: false,
      menuTo: false,
    }
  },
  computed: {
    ...mapState({
      searchingHotel: state => state.app.searchingHotel,
      cotizadorHotels: state => state.app.cotizadorHotels,
      showOcupationRoomHotel: state => state.app.showOcupationRoomHotel,
      cotizadorHotelsResult: state => state.app.cotizadorHotelsResult,
    }),
    computedFromDateFormatted() {
      return this.cotizadorHotels.dateIn ? this.$moment(this.cotizadorHotels.dateIn).format('D-MMM-YY') : ''
    },
    computedToDateFormatted() {
      return this.cotizadorHotels.dateOut ? this.$moment(this.cotizadorHotels.dateOut).format('D-MMM-YY') : ''
    },
    cantViajeros() {
      let cant = 0
      this.cotizadorHotels.ocupation.forEach(element => {
        cant += element.adults + element.childs
      })

      return cant
    },
  },
  watch: {
    searchDestinos(val) {
      if (val.length > 2) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterDestinos(val.toLowerCase())
      } else {
        this.noResultDestinos = false
      }
    },
    searchProveedor(val) {
      if (val !== null && val.length > 0) {
        this.filterProveedor(val.toLowerCase())
      }
    },
    searchTipoDestino(val) {
      // eslint-disable-next-line no-unused-expressions
      this.filterTipoDestino(val.toLowerCase())
    },
  },

  /* mounted() {
    this.scroll()
  }, */
  created() {
    this.getConfigSearch()
    this.getProveedores()
    this.getCategorias()
    this.getTipoDestino()

    if (sessionStorage.getItem('clear-cotization') !== null) {
      this.clearForm()
      sessionStorage.removeItem('clear-cotization')
    }
  },
  methods: {
    ...mapMutations(['setCotizadorHotelsResult', 'setSearchingHotel', 'setShowRoomHotelCotizador']),
    filterDestinos(v) {
      this.itemsDestinos = []
      // eslint-disable-next-line no-empty
      if (v !== '') {
        // DESTINOS
        this.axios
          .post(
            'destinos-hotels-filter-contrate',
            { search: v },
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
              },
            },
          )
          .then(res => {
            const result = res.data.data.data

            result.forEach(element => {
              // eslint-disable-next-line no-nested-ternary
              this.itemsDestinos.push({
                id: element.id,
                name: element.destino,
                icon: 'mdi-map-marker',
                type: 'destino',
                tag: element.tag,
              })
            })
          })

        // HOTELES
        this.axios
          .post(
            'hotels-filter-contrate',
            { search: v },
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
              },
            },
          )
          .then(res => {
            const result = res.data.data.data

            result.forEach(element => {
              // eslint-disable-next-line no-nested-ternary
              this.itemsDestinos.push({
                id: element.id,
                name: element.name,
                icon: 'mdi-bed-outline',
                type: 'hotel',
                tag: 'hotel',
              })
            })
          })

        setTimeout(() => {
          if (this.itemsDestinos.length === 0) {
            this.noResultDestinos = true
          }
        }, 500)
      }
    },
    filterProveedor(v) {
      this.itemsProveedor = []
      if (v === '') {
        this.itemsProveedor = []
      } else {
        this.itemsProveedor = this.proveedores.filter(e => e.name_comercial.toLowerCase())
      }
    },
    filterTipoDestino() {
      this.itemsTipoDestino = this.allTipoDestino.filter(e => e.name.toLowerCase())
    },
    clearForm() {
      this.cotizadorHotels = {
        destino: null,
        dateIn: null,
        dateOut: null,
        proveedor_id: null,
        categoria_id: null,
        tipo_destino_id: null,
        ocupation: [
          {
            adults: 2,
            childs: 0,
            edades: [],
            room_id: null,
            paxs: [],
            showAllPaxs: false,
            priceTotal: null,
            priceWithMarkups: null,
            priceWithDescuento: null,
          },
        ],
      }

      this.setCotizadorHotelsResult([])
      this.setSearchingHotel(false)
    },

    getProveedores() {
      this.axios
        .get('afiliados/byproduct/hotels?only_contrate=1', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.proveedores = res.data.data
        })
    },
    getCategorias() {
      this.axios
        .get(`nom_categorias_hotels?per_page=1000&perfil_slug=${sessionStorage.getItem('perfil')}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.categories = res.data.data
        })
    },
    getTipoDestino() {
      this.axios
        .get(`nom_tipo_destino_hotels?per_page=1000&perfil_slug=${sessionStorage.getItem('perfil')}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.allTipoDestino = res.data.data

          // this.itemsTipoDestino = res.data.data
        })
    },

    getConfigSearch() {
      this.axios
        .get('config-search/hotels', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.configSearch = res.data.data.data.parameters
          if (this.configSearch.days_calendar_in) {
            this.minDate = this.$moment(new Date())
              .add(this.configSearch.days_calendar_in, 'days')
              .toDate()

            this.cotizadorHotels.dateIn = this.minDate.toISOString().substr(0, 10)
            this.cotizadorHotels.dateOut = this.$moment(this.cotizadorHotels.dateIn)
              .add('days', 1)
              .format('YYYY-MM-DD')
          }
        })
    },

    scroll() {
      window.onscroll = () => {
        const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight
        if (bottomOfWindow) {
          if (
            this.cotizadorHotels.destino
            && this.cotizadorHotels.dateIn
            && this.cotizadorHotels.dateOut
            && this.cotizadorHotels.ocupation.length > 0
          ) {
            let proceder = true

            this.cotizadorHotels.ocupation.forEach(room => {
              if (room.childs > 0) {
                room.edades.forEach(edad => {
                  if (!edad.edad) {
                    proceder = false
                  }
                })
              }
            })

            if (proceder) {
              this.page += 1
              const json = this.cotizadorHotels

              // eslint-disable-next-line radix
              json.per_page = parseInt(this.page) * parseInt(this.per_page)

              this.axios
                .post('cotizador-search-hotel', json, {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
                  },
                })
                .then(res => {
                  if (res.data.success) {
                    this.setCotizadorHotelsResult(res.data.data.items)
                  }
                })
            }
          }
        }
      }
    },

    /* clearForm() {
      this.cotizadorHotels.destino = null
      this.cotizadorHotels.dateIn = null
      this.cotizadorHotels.dateOut = null
      this.cotizadorHotels.proveedor_id = null
      this.cotizadorHotels.categoria_id = null
      this.cotizadorHotels.tipo_destino_id = null

      // this.cotizadorHotels.ocupation.length = 0

      this.setCotizadorHotelsResult([])
      this.setSearchingHotel(false)
    }, */

    onPageChange() {
      this.paginando = true
      this.search()
    },
    resetPagination() {
      this.pagination = {
        current: 1,
        total: 0,
      }
    },
    search() {
      if (
        this.cotizadorHotels.destino
        && this.cotizadorHotels.dateIn
        && this.cotizadorHotels.dateOut
        && this.cotizadorHotels.ocupation.length > 0
      ) {
        this.loadingSearch = true
        let proceder = true

        this.cotizadorHotels.ocupation.forEach(room => {
          if (room.childs > 0) {
            room.edades.forEach(edad => {
              if (!edad.edad) {
                proceder = false
              }
            })
          }
        })

        if (proceder) {
          this.setCotizadorHotelsResult([])
          const json = this.cotizadorHotels

          // eslint-disable-next-line radix
          json.page = this.pagination.current
          json.per_page = this.per_page

          // json.per_page = parseInt(this.page) * parseInt(this.per_page)

          // console.log(json)

          this.axios
            .post('cotizador-search-hotel', json, {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
              },
            })
            .then(res => {
              // console.log(res)
              this.setSearchingHotel(true)

              if (res.data.success) {
                this.setCotizadorHotelsResult(res.data.data.items)
                this.pagination.current = res.data.data.page
                this.pagination.total = Math.ceil(parseInt(res.data.data.total_items, 10) / parseInt(this.per_page, 10))
              }
            })
            // eslint-disable-next-line no-return-assign
            .finally(() => {
              this.loadingSearch = false
              this.paginando = false
            })
        } else {
          this.loadingSearch = false
          this.paginando = false
          this.$toast.error(this.$t('msg.datasRequiere'))
        }
      } else {
        this.loadingSearch = false
        this.paginando = false
        this.$toast.error(this.$t('msg.datasRequiere'))
      }
    },

    clearDestinos() {
      this.cotizadorHotels.destino = null
    },
    inputDestinos() {
      if (this.cotizadorHotels.destino.name === null || this.cotizadorHotels.destino.name === '') {
        this.clearDestinos()
      }
    },
    changeDestinos() {
      // console.log(this.cotizadorHotels.destino)
    },

    activeToDate() {
      setTimeout(() => {
        this.menuTo = true
        this.cotizadorHotels.dateOut = this.$moment(this.cotizadorHotels.dateIn)
          .add('days', 1)
          .format('YYYY-MM-DD')
      }, 100)
    },

    changeOcupation() {
      this.setShowRoomHotelCotizador(!this.showOcupationRoomHotel)
    },
  },
}
</script>

<style>
/**PARA OCULTAR LA FECHA DE HOY EN EL COMPONENTE DE HORA */
.vc-date-time .vc-date .vc-weekday,
.vc-date-time .vc-date .vc-month,
.vc-date-time .vc-date .vc-day,
.vc-date-time .vc-date .vc-year {
  display: none;
}

.ps {
  height: 100%;
}
.text-message {
  font-size: 12px;
}
.title {
  font-size: 15px !important;
}
.container-chat {
  position: fixed;
  z-index: 1999;
  top: 6rem;
  right: 1.5rem;
  display: flex;
  flex-direction: column;
}

.theme--light.v-text-field.v-input--is-disabled .v-input__slot:before {
  border: none;
}

.v-input__slot {
  margin-bottom: 0px !important;
}

#app
  > div
  > main
  > div
  > div
  > div
  > div
  > div
  > div.v-card.v-card--flat.v-sheet.theme--light
  > div
  > div
  > div
  > div.v-window-item.v-window-item--active
  > form
  > div
  > div:nth-child(4)
  > div
  > div
  > div
  > div
  > div {
  padding: 0 !important;
}

#app
  > div.v-application--wrap
  > main
  > div
  > div
  > div
  > div
  > div
  > div.v-card.v-card--flat.v-sheet.theme--light
  > div
  > div
  > div
  > div.v-window-item.v-window-item--active
  > form
  > div
  > div:nth-child(4)
  > div
  > div
  > div
  > div
  > div
  > div
  > div:nth-child(3)
  > div {
  padding: 0 !important;
  margin-top: 0 !important;
}

#app
  > div.v-application--wrap
  > main
  > div
  > div
  > div
  > div
  > div
  > div.v-card.v-card--flat.v-sheet.theme--light
  > div
  > div
  > div
  > div.v-window-item.v-window-item--active
  > form
  > div
  > div:nth-child(4)
  > div
  > div
  > div
  > div
  > div
  > div
  > div:nth-child(4)
  > div {
  padding: 0 !important;
  margin-top: 0 !important;
}

#app
  > div
  > main
  > div
  > div
  > div
  > div
  > div
  > div.v-card.v-card--flat.v-sheet.theme--light
  > div
  > div
  > div
  > div.v-window-item.v-window-item--active
  > form
  > div
  > div:nth-child(4)
  > div
  > div
  > div::before {
  box-shadow: none !important;
}

#app
  > div
  > main
  > div
  > div
  > div
  > div
  > div
  > div.v-card.v-card--flat.v-sheet.theme--light
  > div
  > div
  > div
  > div.v-window-item.v-window-item--active
  > form
  > div
  > div:nth-child(4)
  > div
  > div
  > div {
  box-shadow: none !important;
  padding-bottom: 10px;
}
#app
  > div.v-application--wrap
  > main
  > div
  > div
  > div
  > div
  > div
  > div.v-card.v-card--flat.v-sheet.theme--light
  > div
  > div
  > div
  > div.v-window-item.v-window-item--active
  > form
  > div
  > div:nth-child(2)
  > div.pl-0.col-md-3.col-12
  > div
  > div
  > div
  > div
  > label {
  padding-left: 10px !important;
  z-index: 999 !important;
}

#app
  > div
  > main
  > div
  > div
  > div
  > div
  > div
  > div.v-card.v-sheet.theme--light
  > div
  > div
  > div
  > div.v-window-item.v-window-item--active
  > form
  > div
  > div:nth-child(4)
  > div
  > div
  > div {
  box-shadow: none !important;
}

#app
  > div
  > main
  > div
  > div
  > div
  > div
  > div
  > div.v-card.v-sheet.theme--light
  > div
  > div
  > div
  > div.v-window-item.v-window-item--active
  > form
  > div
  > div:nth-child(4)
  > div
  > div
  > div {
  box-shadow: none !important;
}

#app
  > div
  > main
  > div
  > div
  > div
  > div
  > div
  > div.v-card.v-sheet.theme--light
  > div
  > div
  > div
  > div.v-window-item.v-window-item--active
  > form
  > div
  > div:nth-child(4)
  > div
  > div
  > div::before {
  box-shadow: none !important;
}
.boton-lefttMine,
.boton-rightMine {
  max-height: 20px !important;
  min-width: 40px !important;
  padding: 0px !important;
  border: none !important;
}

#weirdButMine {
  border: 1px solid #dcdade;
  max-height: 40px;
  border-radius: 5px;
}

#weirdButMine input {
  height: 20px;
  text-align: center;
}

#weirdButMine div:nth-child(2) > div {
  height: 20px;
  padding: 0;
  margin: 0;
}

#weirdButMine .v-input__slot:after {
  border: none !important;
}

#weirdButMine .v-input__slot:before {
  border: none;
}

#weirdButMine button::before {
  background-color: rgba(255, 255, 255, 0);
}

#weirdButMine button .v-ripple__container {
  color: rgba(255, 255, 255, 0);
  background-color: rgba(255, 255, 255, 0);
}

/* PARA LA FECHA DE VCALENDAR*/
.vc-popover-content-wrapper {
  margin: 0px;
  position: fixed !important;
  inset: 0px auto auto 0px;
  transform: translate(150px, 80px);
}
</style>
